import { memo } from 'react';

import type { CalendarServiceOptions } from './store/types';

import CalendarService from '.';

const App = ({ options }: { options: CalendarServiceOptions }) => <CalendarService options={options} />;

export default memo(App);
